import { useAuth } from 'react-oidc-context';
import { JWT, parseJwt } from '../utils/jwt';
import { useMemo } from 'react';

export interface AuthJWT extends JWT {
  email?: string;
  'cognito:username'?: string;
  uId?: string;
}

const useAuthToken = () => {
  const { user } = useAuth();
  const token = user?.id_token;
  const data = useMemo(() => {
    if (!token) {
      return null;
    }
    return parseJwt<AuthJWT>(token);
  }, [token]);

  return data;
};

export default useAuthToken;
